export type MerchantDoc = {
  id: string
  name?: string
  phone?: string
  status?: 'active' | 'inactive'
  isActive?: boolean
  subscriptionEndDate?: any
  storeActivated?: boolean
  isSuperSeller?: boolean
  createdAt?: any
  updatedAt?: any
  deactivatedBy?: string
  deactivatedReason?: string
}

export type MerchantStatus = 'active' | 'inactive' | 'expiring' | 'unlimited'

export function toJsDate(value: any): Date | null {
  if (!value) return null
  const date = value.toDate ? value.toDate() : new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

export function formatDateAr(value: any): string {
  const date = toJsDate(value)
  if (!date) return '—'
  return date.toLocaleDateString('ar-EG', { year: 'numeric', month: 'short', day: 'numeric' })
}

export function getDaysRemaining(value: any): number | null {
  const endDate = toJsDate(value)
  if (!endDate) return null
  const now = new Date()
  now.setHours(0, 0, 0, 0)
  const end = new Date(endDate)
  end.setHours(0, 0, 0, 0)
  return Math.ceil((end.getTime() - now.getTime()) / (1000 * 60 * 60 * 24))
}

export function getMerchantStatus(merchant: MerchantDoc): MerchantStatus {
  const statusInactive = merchant.status === 'inactive' || merchant.isActive === false
  if (statusInactive) return 'inactive'
  if (!merchant.subscriptionEndDate) return 'unlimited'
  const days = getDaysRemaining(merchant.subscriptionEndDate)
  if (days == null) return 'unlimited'
  if (days < 0) return 'inactive'
  if (days <= 7) return 'expiring'
  return 'active'
}

export function paginate<T>(rows: T[], page: number, rowsPerPage: number): T[] {
  const start = page * rowsPerPage
  return rows.slice(start, start + rowsPerPage)
}
